"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultStyled = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var _helpers_1 = require("../helpers");
var helperFunctions_1 = require("../services/helperFunctions");
var omit_1 = __importDefault(require("lodash/omit"));
exports.DefaultStyled = styled_components_1.default.div.withConfig({
    shouldForwardProp: function (prop, defaultValidatorFn) {
        return defaultValidatorFn(prop) && !['width', 'height', 'fontSize'].includes(prop);
    }
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n  padding: ", ";\n  margin: ", ";\n  font-size: ", ";\n  color: ", ";\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: ", ";\n    color: ", ";\n  }\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: ", ";\n    color: ", ";\n  }\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: ", ";\n    color: ", ";\n  }\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: ", ";\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  height: ", ";\n  width: ", ";\n  padding: ", ";\n  margin: ", ";\n  font-size: ", ";\n  color: ",
    ";\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: ", ";\n    color: ",
    ";\n  }\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: ", ";\n    color: ",
    ";\n  }\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: ", ";\n    color: ",
    ";\n  }\n\n  @media (max-width: ", ") {\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    margin: ", ";\n    font-size: ", ";\n    color: ",
    ";\n  }\n\n  ",
    "\n"])), function (_a) {
    var height = _a.height;
    return helperFunctions_1.toCssProperty(height, 'fullHd');
}, function (_a) {
    var width = _a.width;
    return helperFunctions_1.toCssProperty(width, 'fullHd');
}, function (_a) {
    var padding = _a.padding;
    return helperFunctions_1.toCssProperty(padding, 'fullHd');
}, function (_a) {
    var margin = _a.margin;
    return helperFunctions_1.toCssProperty(margin, 'fullHd');
}, function (_a) {
    var fontSize = _a.fontSize;
    return helperFunctions_1.toCssProperty(fontSize, 'fullHd');
}, function (_a) {
    var _b;
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    var color = typeof dark === 'object'
        ? _helpers_1.setFontColor((_b = dark.fullHd) !== null && _b !== void 0 ? _b : dark.desktop, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme)
        : _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    return color ? color + " !important" : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointWidescreen;
}, function (_a) {
    var height = _a.height;
    return helperFunctions_1.toCssProperty(height, 'widescreen');
}, function (_a) {
    var width = _a.width;
    return helperFunctions_1.toCssProperty(width, 'widescreen');
}, function (_a) {
    var padding = _a.padding;
    return helperFunctions_1.toCssProperty(padding, 'widescreen');
}, function (_a) {
    var margin = _a.margin;
    return helperFunctions_1.toCssProperty(margin, 'widescreen');
}, function (_a) {
    var fontSize = _a.fontSize;
    return helperFunctions_1.toCssProperty(fontSize, 'widescreen');
}, function (_a) {
    var _b;
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    var color = typeof dark === 'object'
        ? _helpers_1.setFontColor((_b = dark.widescreen) !== null && _b !== void 0 ? _b : dark.desktop, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme)
        : _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    return color ? color + " !important" : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointDesktop;
}, function (_a) {
    var height = _a.height;
    return helperFunctions_1.toCssProperty(height, 'desktop');
}, function (_a) {
    var width = _a.width;
    return helperFunctions_1.toCssProperty(width, 'desktop');
}, function (_a) {
    var padding = _a.padding;
    return helperFunctions_1.toCssProperty(padding, 'desktop');
}, function (_a) {
    var margin = _a.margin;
    return helperFunctions_1.toCssProperty(margin, 'desktop');
}, function (_a) {
    var fontSize = _a.fontSize;
    return helperFunctions_1.toCssProperty(fontSize, 'desktop');
}, function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    var color = typeof dark === 'object'
        ? _helpers_1.setFontColor(dark.desktop, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme)
        : _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    return color ? color + " !important" : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointTablet;
}, function (_a) {
    var height = _a.height;
    return helperFunctions_1.toCssProperty(height, 'tablet');
}, function (_a) {
    var width = _a.width;
    return helperFunctions_1.toCssProperty(width, 'tablet');
}, function (_a) {
    var padding = _a.padding;
    return helperFunctions_1.toCssProperty(padding, 'tablet');
}, function (_a) {
    var margin = _a.margin;
    return helperFunctions_1.toCssProperty(margin, 'tablet');
}, function (_a) {
    var fontSize = _a.fontSize;
    return helperFunctions_1.toCssProperty(fontSize, 'tablet');
}, function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    var color = typeof dark === 'object'
        ? _helpers_1.setFontColor(dark.tablet, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme)
        : _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    return color ? color + " !important" : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
}, function (_a) {
    var height = _a.height;
    return helperFunctions_1.toCssProperty(height, 'mobile');
}, function (_a) {
    var width = _a.width;
    return helperFunctions_1.toCssProperty(width, 'mobile');
}, function (_a) {
    var padding = _a.padding;
    return helperFunctions_1.toCssProperty(padding, 'mobile');
}, function (_a) {
    var margin = _a.margin;
    return helperFunctions_1.toCssProperty(margin, 'mobile');
}, function (_a) {
    var fontSize = _a.fontSize;
    return helperFunctions_1.toCssProperty(fontSize, 'mobile');
}, function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    var color = typeof dark === 'object'
        ? _helpers_1.setFontColor(dark.mobile, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme)
        : _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    return color ? color + " !important" : '';
}, function (_a) {
    var defaultCss = _a.defaultCss;
    return defaultCss && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), helperFunctions_1.convertToCssString(omit_1.default(defaultCss, ['color'])));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=DefaultStyled.js.map